import React from "react";
import logo from '../../Assets/images/ConnectHealthPro.png';

const footerStyles = `
  :root {
    --gray-200: #e5e7eb;
    --gray-600: #4b5563;
    --gray-700: #374151;
    --white: #ffffff;
  }

  .footer {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    background-color: var(--white);
    padding: 1rem 1.5rem;
    color: var(--gray-600);
    font-size: 0.875rem;
    box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.05);
    border-top: 1px solid var(--gray-200);
    width: 100%;
    box-sizing: border-box;
    flex-shrink: 0; /* ✅ Prevent footer from shrinking in flex layout */
  }

  .footer-copyright {
    text-align: center;
    margin-bottom: 1rem;
  }

  .footer-powered-by {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .footer-powered-by span {
    margin-right: 0.75rem;
    color: var(--gray-700);
    font-weight: 500;
  }

  .footer-logo {
    width: 7rem;
    height: auto;
  }

  @media (min-width: 768px) {
    .footer {
      flex-direction: row;
      padding: 1rem 2rem;
    }

    .footer-copyright {
      text-align: left;
      margin-bottom: 0;
    }

    .footer-logo {
      width: 8rem;
    }
  }

  @media (min-width: 1024px) {
    .footer {
      padding: 1rem 3rem;
    }
  }
`;

const Footer = () => (
  <>
    <style dangerouslySetInnerHTML={{ __html: footerStyles }} />
    <footer className="footer">
      <div className="footer-copyright flex">
        <a
          href="/Terms-and-Conditions_Consent-Policy_Privacy-Policy.pdf"
          target="_blank"
          rel="noopener noreferrer"
          style={{ marginLeft: "10px", marginRight: "10px", }}
        >
          Terms of Service
        </a>{" "}
        <p>&copy; {new Date().getFullYear()} Connect Health Pro. All rights reserved.</p>
      </div>
      <div className="footer-powered-by">
        <span>Powered By:</span>
        <img src={logo} alt="Connect Health Pro Logo" className="footer-logo" />
      </div>
    </footer>
  </>
);

export default Footer;
